import { Box } from '@coolblue-development/becky';
import { useEffect, useRef } from 'react';
import { useEmailContext } from '../../../../contexts/EmailContext';
import EmailTab from './EmailTab';
import CreateOutboundEmailButton from './Outbound/CreateOutboundEmailButton';
import postEvent from '../../../../services/postEvent';
import getCurrentTime from '../../../../utils/timeFactory';
import { datadogLogs } from '@datadog/browser-logs';
import { useAppContext } from '../../../../AppContext';
import { EMAIL_INITIATION_METHODS } from '../../../../constants/email';
import { EMAIL_FOCUS_TIMESTAMP_KEY } from '../../../../constants/localStorage';

const EmailSidePanel = (): JSX.Element => {
  const { emailContacts, outboundContactId } = useEmailContext();
  const { agent } = useAppContext();
  const prevOutboundContactId = useRef<string | null>(null);

  useEffect(() => {
    const currentTime = getCurrentTime();

    if (prevOutboundContactId.current && !outboundContactId) {
      const previousTimestamp = localStorage.getItem(EMAIL_FOCUS_TIMESTAMP_KEY);

      if (previousTimestamp) {
        void postEvent(
          prevOutboundContactId.current,
          'focus',
          { startedAt: new Date(JSON.parse(previousTimestamp) as string), endedAt: currentTime },
          'EMAIL',
          EMAIL_INITIATION_METHODS.OUTBOUND
        ).catch((error: Error) => {
          datadogLogs.logger.warn('Failed to post email focus event', { error, agent: agent?.getName() });
        });

        localStorage.removeItem(EMAIL_FOCUS_TIMESTAMP_KEY);
      }
    }

    if (outboundContactId) {
      localStorage.setItem(EMAIL_FOCUS_TIMESTAMP_KEY, JSON.stringify(currentTime));
    }

    prevOutboundContactId.current = outboundContactId;
  }, [outboundContactId]);

  return (
    <Box>
      <CreateOutboundEmailButton />
      {emailContacts.map(contactId => (
        <EmailTab key={contactId} contactId={contactId} />
      ))}
    </Box>
  );
};

export default EmailSidePanel;
